var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hub-artworks"},[_c('div',{staticClass:"container"},[_c('h2',[_vm._v(_vm._s(_vm.heading))])]),_vm._v(" "),_c('List',{attrs:{"increment":_vm.increment,"artworks":_vm.filteredArtworks,"is-external":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }